import { render } from "./GameProperties.vue?vue&type=template&id=6eb64705"
import script from "./GameProperties.vue?vue&type=script&lang=js"
export * from "./GameProperties.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/craft-fos-scoutsmap/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__